import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AddShortlistModal from './AddShortlistModal';
import ShortlistFormModal from './ShortlistFormModal';
import DeleteShortlistModal from './DeleteShortListModal';
import AddProjectToShortlist from './AddProjectToShortlist';
import { OverflowMenu, MENU_ICONS as ICONS } from '../../../components/MenuOptions/OverflowMenu';

interface Shortlist {
  id: number;
  name: string;
  deactivated: boolean;
  created_at: string;
  updated_at: string;
  experts: any[];
}

interface Props {
  shortlist: Shortlist;
  fetchShortlists: any;
}

const ShortlistCardMenu = ({ shortlist, fetchShortlists }: Props) => {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editShortlistId, setEditShortlistId] = useState<number | null>(null);
  const [deleteShortlistId, setDeleteShortlistId] = useState<number | null>(
    null
  );
  const [editShortlistName, setEditShortlistName] = useState('');
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [showProjectModal, setShowProjectModal] = useState(false);
  const [duplicateNameModalOpen, setDuplicateNameModalOpen] = useState(false);

  const navigate = useNavigate();

  const handleEditShortlist = () => {
    setEditShortlistId(shortlist.id);
    setEditShortlistName(shortlist.name);
    setEditModalOpen(true);
  };

  const [modalOpen, setModalOpen] = useState(false);

  const share = () => {
    if (!shortlist?.id) return;
    const url = `/experts/share?shortlistId=${shortlist.id}`;
    window.open(url, '_blank');
  };

  const handleDeleteShortlist = () => {
    setDeleteShortlistId(shortlist.id);
    setDeleteModalOpen(true);
  };

  if (!shortlist) return null;

  const groups = [
    {
      label: 'Get',
      items: [
        { key: 'view', label: 'View', icon: ICONS.view, onClick: () => navigate(`/experts/shortlists/${shortlist.id}?shortlist=${shortlist.id}`) },
        { key: 'share', label: 'Share URL', icon: ICONS.share, onClick: share },
      ],
    },
    {
      label: 'Organize',
      items: [
        { key: 'add-expert', label: 'Add Expert', icon: ICONS.addPerson, onClick: () => setModalOpen(true) },
        { key: 'add-project', label: 'Add to Project', icon: ICONS.project, onClick: () => setShowProjectModal(true) },
      ],
    },
    {
      label: 'Edit',
      items: [
        { key: 'edit', label: 'Edit', icon: ICONS.edit, onClick: handleEditShortlist },
        { key: 'duplicate', label: 'Duplicate', icon: ICONS.duplicate, onClick: () => setDuplicateNameModalOpen(true) },
      ],
    },
    {
      label: '',
      items: [
        { key: 'delete', label: 'Delete', icon: ICONS.trash, danger: true, onClick: handleDeleteShortlist },
      ],
    },
  ];

  return (
    <>
      <OverflowMenu groups={groups} ariaLabel="Shortlist actions" width={230} />

      <AddShortlistModal
        open={modalOpen}
        setOpen={setModalOpen}
        shortlist={shortlist}
        refresh={() => {
          fetchShortlists();
        }}
      />

      {editShortlistId !== null && (
        <ShortlistFormModal
          mode="edit"
          open={editModalOpen}
          setOpen={setEditModalOpen}
          shortlistId={editShortlistId}
          currentName={editShortlistName}
          fetchShortlists={fetchShortlists}
          updateShortlistName={() => {}}
        />
      )}

      {deleteShortlistId !== null && (
        <DeleteShortlistModal
          open={deleteModalOpen}
          setOpen={setDeleteModalOpen}
          shortlistId={deleteShortlistId}
          fetchShortlists={fetchShortlists}
        />
      )}

      {showProjectModal && (
        <AddProjectToShortlist
          open={showProjectModal}
          setOpen={setShowProjectModal}
          shortlistId={shortlist.id}
          onSuccess={fetchShortlists}
        />
      )}

      {duplicateNameModalOpen && (
        <ShortlistFormModal
          mode="duplicate"
          open={duplicateNameModalOpen}
          setOpen={setDuplicateNameModalOpen}
          shortlistId={shortlist.id}
          currentName={shortlist.name}
          onShortlistCreated={fetchShortlists}
        />
      )}
    </>
  );
};

export default ShortlistCardMenu;
